
{
  "familyId": "MET-TIJD-NAUWKEURIG",
  "questions": [
    {
      "id": "MET-TIJD-NAUWKEURIG-001",
      "familyId": "MET-TIJD-NAUWKEURIG",
      "module": "Metriek",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "tijd_meten",
      "subSkill": "tijd_nauwkeurig_meten",
      "questionType": "multiple_choice",
      "question": "Een hardloper loopt de 100 meter in 12,45 seconden. Hoeveel tienden van een seconde is dat achter de komma?",
      "options": ["4 tienden", "45 tienden", "5 tienden", "12 tienden"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Tienden en honderdsten van een seconde",
            "content": "Het eerste cijfer achter de komma zijn de tienden. Het tweede cijfer zijn de honderdsten. In 12,45 is de 4 het tiendencijfer en de 5 het honderdstencijfer.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "tijd_nauwkeurig_tienden",
      "variantIndex": 1,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "Kijk naar 12,45. Het eerste cijfer achter de komma is de 4 — dat zijn de tienden. Het tweede cijfer (5) zijn de honderdsten. Dus er zijn 4 tienden achter de komma. Waarom is dit belangrijk? Bij atletiek kan het verschil tussen winnen en verliezen 1 tiende van een seconde zijn.",
        "solutionSteps": [
          "Kijk naar het getal 12,45",
          "Eerste cijfer achter de komma: 4 = tienden",
          "Tweede cijfer achter de komma: 5 = honderdsten",
          "Antwoord: 4 tienden"
        ],
        "distractorExplanations": {
          "0": "Goed! De 4 in 12,45 staat op de tiendenplek — dat zijn 4 tienden van een seconde.",
          "1": "Je dacht waarschijnlijk dat 45 samen de tienden zijn. Maar 45 zijn de tienden én honderdsten samen. Alleen de 4 is het tiendencijfer. Onthoud: het eerste cijfer achter de komma = tienden.",
          "2": "Je dacht waarschijnlijk dat de 5 de tienden zijn. Maar de 5 staat op de honderdstenplek (tweede cijfer achter de komma). De 4 staat op de tiendenplek. Onthoud: tel van links naar rechts achter de komma.",
          "3": "Je dacht waarschijnlijk dat het getal vóór de komma de tienden zijn. Maar 12 zijn de hele seconden. De tienden staan achter de komma. Onthoud: tienden = eerste cijfer achter de komma."
        }
      }
    },
    {
      "id": "MET-TIJD-NAUWKEURIG-002",
      "familyId": "MET-TIJD-NAUWKEURIG",
      "module": "Metriek",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "tijd_meten",
      "subSkill": "tijd_nauwkeurig_meten",
      "questionType": "multiple_choice",
      "question": "Twee zwemmers finishen op 28,34 s en 28,38 s. Hoeveel honderdsten van een seconde zit er tussen?",
      "options": ["4 honderdsten", "40 honderdsten", "34 honderdsten", "0,4 seconde"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Verschil in honderdsten",
            "content": "Om het verschil in honderdsten te vinden: kijk naar de laatste twee cijfers achter de komma. 38 − 34 = 4 honderdsten.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "tijd_nauwkeurig_verschil",
      "variantIndex": 2,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "Beide tijden beginnen met 28,3... Het verschil zit in de honderdsten: 38 − 34 = 4 honderdsten van een seconde. Dat is 0,04 seconde. Waarom niet 0,4? Omdat 0,4 seconde = 40 honderdsten — dat is 10× zoveel. Check: 28,34 + 0,04 = 28,38 ✓",
        "solutionSteps": [
          "Vergelijk: 28,34 en 28,38",
          "De hele seconden zijn gelijk: 28",
          "De tienden zijn gelijk: 3",
          "Verschil in honderdsten: 8 − 4 = 4",
          "Antwoord: 4 honderdsten (= 0,04 s)"
        ],
        "distractorExplanations": {
          "0": "Goed! 28,38 − 28,34 = 0,04 seconde = 4 honderdsten.",
          "1": "Je dacht waarschijnlijk dat je 38 − 34 = 4 moet vermenigvuldigen met 10. Maar het verschil is al in honderdsten: 4 honderdsten, niet 40. Onthoud: honderdsten zijn het tweede cijfer achter de komma.",
          "2": "Je dacht waarschijnlijk dat je de hele honderdsten van één tijd moet nemen. Maar de vraag is het verschil: 38 − 34 = 4 honderdsten. Onthoud: trek de twee tijden van elkaar af.",
          "3": "Je dacht waarschijnlijk dat 4 honderdsten hetzelfde is als 0,4 seconde. Maar 4 honderdsten = 0,04 seconde. 0,4 seconde = 40 honderdsten. Onthoud: 1 tiende = 10 honderdsten."
        }
      }
    },
    {
      "id": "MET-TIJD-NAUWKEURIG-003",
      "familyId": "MET-TIJD-NAUWKEURIG",
      "module": "Metriek",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "tijd_meten",
      "subSkill": "tijd_nauwkeurig_meten",
      "questionType": "multiple_choice",
      "question": "Een sportcoach meet een sprint met een stopwatch die tienden van seconden toont. De stopwatch staat op 00:14.7. Hoeveel seconden is dat precies?",
      "options": ["14,7 seconden", "14,07 seconden", "147 seconden", "1 minuut en 4,7 seconden"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Stopwatch aflezen",
            "content": "Op een stopwatch staat 00:14.7. De 00 = minuten, 14 = seconden, 7 = tienden van een seconde. Dus 14,7 seconden.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "tijd_nauwkeurig_stopwatch",
      "variantIndex": 3,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.76,
      "feedback": {
        "explanationText": "De stopwatch toont 00:14.7. De 00 zijn de minuten (nul minuten). De 14 zijn de seconden. De 7 achter de punt is tienden van een seconde. Dus: 14,7 seconden. Waarom niet 14,07? Omdat er maar 1 cijfer achter de punt staat — dat zijn tienden, niet honderdsten.",
        "solutionSteps": [
          "Lees de stopwatch: 00:14.7",
          "00 = 0 minuten",
          "14 = 14 seconden",
          ".7 = 7 tienden van een seconde",
          "Antwoord: 14,7 seconden"
        ],
        "distractorExplanations": {
          "0": "Goed! 00:14.7 = 0 minuten en 14,7 seconden.",
          "1": "Je dacht waarschijnlijk dat de 7 op de honderdstenplek staat. Maar de stopwatch toont tienden, niet honderdsten. 14.7 = 14,7 seconden, niet 14,07. Onthoud: kijk hoeveel cijfers achter de punt staan.",
          "2": "Je dacht waarschijnlijk dat je alle cijfers achter elkaar moet lezen. Maar 00:14.7 is niet 147 seconden — de dubbele punt scheidt minuten van seconden. Onthoud: lees minuten:seconden.tienden.",
          "3": "Je dacht waarschijnlijk dat de 14 minuten en seconden samen zijn. Maar de 00 vóór de dubbele punt zijn de minuten (nul). De 14 zijn alleen seconden. Onthoud: het eerste getal = minuten."
        }
      }
    },
    {
      "id": "MET-TIJD-NAUWKEURIG-004",
      "familyId": "MET-TIJD-NAUWKEURIG",
      "module": "Metriek",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "tijd_meten",
      "subSkill": "tijd_nauwkeurig_meten",
      "questionType": "multiple_choice",
      "question": "Bij een schaatswedstrijd rijdt Sanne 500 meter in 42,156 seconden. De jury rondt af op honderdsten. Wat wordt haar officiële tijd?",
      "options": ["42,16 seconden", "42,15 seconden", "42,2 seconden", "42,156 seconden"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Afronden op honderdsten",
            "content": "Kijk naar het duizendstencijfer (6). Is het 5 of meer? Dan rond je naar boven af. 42,156 → 42,16 (de 5 wordt 6 door de 6 erachter).",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "tijd_nauwkeurig_afronden",
      "variantIndex": 4,
      "citoDifficulty": 0.38,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "Afronden op honderdsten: kijk naar het duizendstencijfer. In 42,156 is dat de 6. Omdat 6 ≥ 5, rond je naar boven af: de 5 op de honderdstenplek wordt 6. Dus 42,156 → 42,16 seconden. Waarom naar boven? Omdat het duizendstencijfer (6) aangeeft dat je dichter bij 42,16 zit dan bij 42,15.",
        "solutionSteps": [
          "Kijk naar 42,156 — we ronden af op honderdsten",
          "Het honderdstencijfer is 5, het duizendstencijfer is 6",
          "6 ≥ 5, dus rond naar boven af: 5 → 6",
          "Antwoord: 42,16 seconden",
          "Check: 42,156 ligt tussen 42,15 en 42,16, dichter bij 42,16 ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! 42,156 afgerond op honderdsten = 42,16 seconden.",
          "1": "Je dacht waarschijnlijk dat je naar beneden afrondt. Maar het duizendstencijfer is 6 (≥ 5), dus je rondt naar boven af: 42,15_ → 42,16. Onthoud: 5 of meer = naar boven.",
          "2": "Je dacht waarschijnlijk dat je op tienden moet afronden. Maar de jury rondt af op honderdsten (2 cijfers achter de komma). 42,2 is afgerond op tienden. Onthoud: honderdsten = 2 cijfers achter de komma.",
          "3": "Je dacht waarschijnlijk dat je niet hoeft af te ronden. Maar de jury wil de tijd op honderdsten — 2 cijfers achter de komma. 42,156 heeft 3 cijfers, dus je moet afronden. Onthoud: afronden = minder cijfers."
        }
      }
    },
    {
      "id": "MET-TIJD-NAUWKEURIG-005",
      "familyId": "MET-TIJD-NAUWKEURIG",
      "module": "Metriek",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "tijd_meten",
      "subSkill": "tijd_nauwkeurig_meten",
      "questionType": "fill_in",
      "question": "Een atleet loopt de 200 meter in 25,8 seconden. Hoeveel honderdsten van een seconde is 25,8? Typ het aantal honderdsten (bijv. 2580).",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "acceptedAnswers": ["2580"],
        "caseSensitive": false,
        "placeholder": "... honderdsten"
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Seconden naar honderdsten",
            "content": "1 seconde = 100 honderdsten. Dus vermenigvuldig het aantal seconden met 100. 25,8 × 100 = 2580 honderdsten.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "tijd_nauwkeurig_omrekenen",
      "variantIndex": 5,
      "citoDifficulty": 0.40,
      "citoDiscrimination": 0.70,
      "feedback": {
        "explanationText": "1 seconde = 100 honderdsten. Dus 25,8 seconden = 25,8 × 100 = 2580 honderdsten. De komma schuift 2 plekken naar rechts. Waarom ×100? Omdat er 100 honderdsten in 1 seconde gaan. Check: 2580 ÷ 100 = 25,8 s ✓",
        "solutionSteps": [
          "1 seconde = 100 honderdsten",
          "25,8 × 100 = 2580",
          "Antwoord: 2580 honderdsten",
          "Check: 2580 ÷ 100 = 25,8 s ✓"
        ]
      }
    }
  ]
}
